import React from 'react'
import { Box, Typography } from '@mui/material'
import { st, stDesk } from './styles'
import { semFoto } from '../../../assets'

export default function CompTorneio({ nomeEmpresa, fotoEmpresa, torneio, onClick, mode = 'simples', select = false }) {
  if (mode === 'simples') {
    return (
      <Box
        sx={{ ...st.contain, backgroundImage: `url(${torneio.foto || semFoto})` }}
        onError={e => {
          e.target.onerror = null
          e.target.src = semFoto
        }}
        onClick={onClick}
      >
        <Box sx={st.containCenter}>
          <img
            src={fotoEmpresa}
            alt={torneio.titulo}
            style={st.imagem}
            onError={e => {
              e.target.onerror = null
              e.target.src = semFoto
            }}
          />
          <Box sx={st.containText}>
            <Typography component='h3' sx={st.title}>
              {nomeEmpresa}
            </Typography>
            <Typography component='h5' sx={st.subtitle}>
              {torneio.titulo}
            </Typography>
          </Box>
        </Box>
      </Box>
    )
  } else {
    return (
      <Box
        sx={{
          ...stDesk.containComp,
          boxShadow: select
            ? '4px 4px 4px 4px rgba(0,0,0,0.5)' // Sombra mais forte quando selecionado
            : '0px 0px 8px 0px rgba(0,0,0,0.2)', // Sombra padrão
          transition: 'box-shadow 0.3s ease-in-out', // Suaviza a transição da sombra
        }}
        onClick={onClick}
      >
        <Box
          sx={{ ...stDesk.containHeader, backgroundImage: `url(${torneio.foto || semFoto})` }}
          onError={e => {
            e.target.onerror = null
            e.target.src = semFoto
          }}
        >
          <Box sx={stDesk.containNight}>
            <img src={fotoEmpresa} alt={torneio.titulo} style={stDesk.imagem} />
            <Box sx={st.containText}>
              <Typography component='h3' sx={st.title}>
                {nomeEmpresa}
              </Typography>
              <Typography component='h5' sx={st.subtitle}>
                {torneio.titulo}
              </Typography>
            </Box>
          </Box>
        </Box>
        <Box sx={stDesk.containBottom}>
          <Box sx={stDesk.containResumo}>
            <Typography component='p' sx={st.text}>
              Resumo
            </Typography>
            <Typography component='p' sx={st.subText}>
              {torneio.descricao}
            </Typography>
            <Typography component='p' sx={st.subText}>
              Modelo: {torneio.modeloTorneio}
            </Typography>
          </Box>
        </Box>
      </Box>
    )
  }
}
